<ng-container *ngIf="!isLander">
  <div class="home">
    <div *ngIf="isBannerEnabled" class="home_banner">
      <div class="home_banner__carousel">
        <ngb-carousel
          class="carousel_fade"
          [showNavigationArrows]="showIndicators"
          [showNavigationIndicators]="showIndicators"
        >
          <ng-container *ngFor="let discoverItem of discoverData">
            <ng-template *ngIf="discoverItem?.featured" ngbSlide>
              <div
                [class.banner_image__wrapper--loaded]="discoverItem.isLoaded"
                class="picsum-img-wrapper"
              >
                <img
                  [src]="discoverItem.banner_image"
                  [class.banner_image__item--error]="discoverItem.hasError"
                  [class.banner_image__item--loaded]="discoverItem.isLoaded"
                  (error)="onImageStateChange($event, discoverItem)"
                  (load)="onImageStateChange($event, discoverItem)"
                  alt="slide"
                />
              </div>
              <div class="carousel-caption flex">
                <div class="home_banner__info">
                  <div>
                    <p class="home_banner__name">Chat with {{ discoverItem.name }}</p>
                    <p class="home_banner__description">{{ discoverItem.description }}</p>
                  </div>
                  <stxt-button
                    (click)="navigateToChat(chatNavButton.text, discoverItem)"
                    (keydown.enter)="navigateToChat(chatNavButton.text, discoverItem)"
                    [buttonConfig]="chatNavButton"
                    class="home_banner__button"
                  >
                    {{ chatNavButton.text }}
                  </stxt-button>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </ngb-carousel>
      </div>
    </div>
    <div *ngIf="discoverData" class="home_main">
      <div
        class="home_main__heading"
        [ngStyle]="{ margin: isFiltersEnabled ? '0 auto' : '0 auto 25px' }"
      >
        <p>
          Discover real personalities as
          <span>AI fantasies</span>
        </p>
      </div>
      <stxt-discover-filters
        *ngIf="isFiltersEnabled"
        [nationalityFilters]="nationalityFilters"
        [filters]="availableFilters"
        (filterSelected)="filterCards($event)"
        class="home_main__filters"
      ></stxt-discover-filters>
      <div class="home_main__items">
        <ng-container *ngFor="let discoverItem of filteredDiscoverData">
          <stxt-discover-item
            [discoverItem]="discoverItem"
            [userId]="userId"
            [selectedPreviewAudio]="selectedPreviewAudio"
            [isNew]="discoverItem.isNew"
            (updatePreviewVoiceState)="trackSelectedVoice($event)"
            class="home_main__item"
          ></stxt-discover-item>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
